export default "__VITE_ASSET__wlWUT4qz__"